import React, { Component } from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "./TextFont";
import PropTypes from "prop-types";
import { SimpleIcon } from "../components_v2/Buttons";
import Theme from "../argon-ui/Theme";

import { IS_WEB, RIGHT, translate } from "../locales/translate";

import {
  THERMOSTAT_FAN_MODE,
  THERMOSTAT_MODE,
  THERMOSTAT_FAN_STATE,
  THERMOSTAT_OPERATING_STATE,
  ZHVAC_MODE,
  ZHVAC_FAN_SPEED,
} from "../../assets/consts";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import Switch from "../components/ToggleSwitch";
import { HStack } from "native-base";

const COLORS = {
  WHITE: "#FFF",
  MUTED: Theme.COLORS.MUTED,
  BORDER: "#99cc99",
  BORDER: "#99cc99",
  PRIMARY: Theme.COLORS.PRIMARY,
  ECONOMY_BACKGROUND: "#fff",
  ECONOMY_ACTIVE: "#99cc99", //"#4ab54a",
  ECONOMY_DE_ACTIVE: "#ddd",
};

/**@augments{Component<Props,state>} */
class AirConditionerThermostat extends Component {
  static propTypes = {
    deviceId: PropTypes.number,
    deviceName: PropTypes.string,
    isTurnedOn: PropTypes.bool,
    currentTemperature: PropTypes.number,
    humidity: PropTypes.number,
    setPoint: PropTypes.number,
    setPointUnit: PropTypes.string,
    thermostatFanMode: PropTypes.number,
    thermostatFanState: PropTypes.number,
    thermostatMode: PropTypes.number,
    thermostatEconomyEnabled: PropTypes.bool,
    thermostatOperatingState: PropTypes.number,
    zhvacUnitNumber: PropTypes.number,
    zhvacMode: PropTypes.number,
    zhvacFanSpeed: PropTypes.number,

    onThermostatFanModeChange: PropTypes.func,
    onThermostatModeChange: PropTypes.func,
    onSetPointChange: PropTypes.func,
    onToggle: PropTypes.func,
  };
  constructor(props) {
    super(props);

    this.state = {
      setPoint: undefined,
      isAuto: undefined,
      thermostatFanMode: undefined,
      thermostatMode: undefined,
      economyEnabled: undefined,
      isChangingMode: false,
    };
  }

  componentDidMount() {}

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.setPoint != prevState.setPoint &&
      prevState.setPoint != undefined
    ) {
      prevState.setPoint = undefined;
    }

    if (
      nextProps.thermostatMode != prevState.thermostatMode &&
      prevState.thermostatMode != undefined
    ) {
      prevState.thermostatMode = undefined;
    }

    if (
      nextProps.thermostatEconomyEnabled != prevState.economyEnabled &&
      prevState.thermostatMode != undefined
    ) {
      prevState.economyEnabled = undefined;
    }

    return { ...prevState };
  }

  showThermostatModes = () => {
    this.setState({ isChangingMode: true });
  };

  getThermostatModeIcon = (mode, unitNumber = 0) => {
    var icon = undefined;

    if (unitNumber != 0) {
      // ZHVAC
      switch (mode) {
        case ZHVAC_MODE.auto:
          icon = faCharCodes.faSyncAlt;
          break;
        case ZHVAC_MODE.cool:
          icon = faCharCodes.faSnowflake;
          break;
        case ZHVAC_MODE.dry:
          icon = faCharCodes.faTintSlash;
          break;
        case ZHVAC_MODE.heat:
          icon = faCharCodes.faHeat;
          break;
        default:
          icon = faCharCodes.faFan;
          break;
      }
    } else {
      switch (mode) {
        case THERMOSTAT_MODE.heat:
          icon = faCharCodes.faHeat;
          break;
        //case THERMOSTAT_MODE.auto:
        case THERMOSTAT_MODE.autoChangeover:
          icon = faCharCodes.faSyncAlt;
          break;
        case THERMOSTAT_MODE.cool:
          icon = faCharCodes.faSnowflake;
          break;
        case THERMOSTAT_MODE.moist:
          icon = faCharCodes.faTint;
          break;
        case THERMOSTAT_MODE.dry:
          icon = faCharCodes.faTintSlash;
          break;
        case THERMOSTAT_MODE.fan:
          icon = faCharCodes.faFan;
          break;
        default:
          break;
      }
    }

    return icon;
  };

  getThermostatOperatingStateIcon = (mode) => {
    var icon = "";

    switch (mode) {
      case THERMOSTAT_OPERATING_STATE.heating:
        icon = faCharCodes.faHeat;
        break;
      case THERMOSTAT_OPERATING_STATE.cooling:
        icon = faCharCodes.faSnowflake;
        break;
      default:
        break;
    }

    return icon;
  };

  renderMode = () => {
    var mode = this.state.thermostatMode;
    var unitNumber = this.props.zhvacUnitNumber;
    if (mode == undefined) mode = this.props.thermostatMode;
    if (unitNumber > 0) mode = this.props.zhvacMode;
    var icon = this.getThermostatModeIcon(mode, unitNumber);
    return (
      <View
        style={{
          flex: 1,
          width: "100%",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        {this.renderModeIcon(icon, 24, true, this.showThermostatModes)}
        {this.renderEconomy()}
      </View>
    );
  };

  renderModes = (zhvacUnitNumber) => {
    var modes = [];
    for (const i in THERMOSTAT_MODE) {
      const mode = THERMOSTAT_MODE[i];
      if (zhvacUnitNumber == 0 || mode != THERMOSTAT_MODE.moist) {
        var icon = this.getThermostatModeIcon(mode);
        if (icon) {
          modes.push({ mode, icon });
        }
      }
    }
    var _thermostatMode = this.state.thermostatMode;
    if (_thermostatMode == undefined)
      _thermostatMode = this.props.thermostatMode;
    return (
      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {modes.map((mode, i) => {
          return (
            <View style={{ marginHorizontal: 6, marginVertical: 3 }} key={i}>
              {this.renderModeIcon(
                mode.icon,
                14,
                mode.mode == _thermostatMode,
                () => this.changeMode(mode.mode)
              )}
            </View>
          );
        })}
      </View>
    );
  };

  renderEconomy = () => {
    return (
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <HStack space="2" style={styles.economyButtonContainer}>
          <TouchableOpacity
            style={[
              styles.economyButton,
              {
                backgroundColor: this.props.thermostatEconomyEnabled
                  ? COLORS.ECONOMY_ACTIVE
                  : COLORS.ECONOMY_DE_ACTIVE,
              },
            ]}
            onPress={() => this.changeEconomy(true)}
          >
            <Text style={styles.economyButtonText}>ECO</Text>
          </TouchableOpacity>
          <Text>|</Text>
          <TouchableOpacity
            style={[
              styles.economyButton,
              {
                backgroundColor: !this.props.thermostatEconomyEnabled
                  ? COLORS.ECONOMY_ACTIVE
                  : COLORS.ECONOMY_DE_ACTIVE,
              },
            ]}
            onPress={() => this.changeEconomy(false)}
          >
            <Text style={styles.economyButtonText}>COM</Text>
          </TouchableOpacity>
        </HStack>
      </View>
    );
  };

  renderModeIcon = (
    icon,
    size = 24,
    isSelected = false,
    onPress = () => {}
  ) => {
    var w = Math.floor(size * 1.5);
    var rd = w / 2;
    var wrapperStyle = {
      width: w,
      height: w,
      borderRadius: rd,
      backgroundColor: COLORS.MUTED,
    };
    if (isSelected) wrapperStyle.backgroundColor = COLORS.BORDER;
    return (
      <TouchableOpacity
        style={[styles.circleButton, wrapperStyle]}
        onPress={() => {
          typeof onPress === "function" && onPress();
        }}
      >
        <SimpleIcon icon={icon} size={size} />
      </TouchableOpacity>
    );
  };

  changeSetPoint = (newValue) => {
    if (Number(newValue) >= 0) {
      this.setState({ setPoint: newValue }, () => {
        typeof this.props.onSetPointChange === "function" &&
          this.props.onSetPointChange(newValue);
      });
    }
  };

  changeFanMode = (mode) => {
    var isAuto = false;
    if (
      mode == THERMOSTAT_FAN_MODE.autoLow ||
      mode == THERMOSTAT_FAN_MODE.autoMedium ||
      mode == THERMOSTAT_FAN_MODE.autoHigh
    ) {
      isAuto = true;
    }
    this.setState({ thermostatFanMode: mode, isAuto }, () => {
      typeof this.props.onThermostatFanModeChange === "function" &&
        this.props.onThermostatFanModeChange(mode);
    });
  };

  changeMode = (mode) => {
    this.setState({ thermostatMode: mode, isChangingMode: false }, () => {
      typeof this.props.onThermostatModeChange === "function" &&
        this.props.onThermostatModeChange(
          mode,
          this.props.thermostatEconomyEnabled || false
        );
    });
  };

  onToggle = (value = true) => {
    typeof this.props.onToggle == "function" && this.props.onToggle(value);
  };

  changeEconomy = (economyEnabled) => {
    this.setState({
      thermostatEconomyEnabled: economyEnabled,
    });
    typeof this.props.onThermostatModeChange === "function" &&
      this.props.onThermostatModeChange(
        this.props.thermostatMode,
        economyEnabled
      );
  };

  renderFanMode = () => {
    var isLow = false,
      isMedium = false,
      isHigh = false,
      isAuto = false;
    var _thermostatFanMode = this.state.thermostatFanMode;

    if (this.props.zhvacUnitNumber > 0) {
      switch (this.props.zhvacFanSpeed) {
        case ZHVAC_FAN_SPEED.low:
          isLow = true;
          _thermostatFanMode = THERMOSTAT_FAN_MODE.low;
          break;
        case ZHVAC_FAN_SPEED.mid:
          _thermostatFanMode = THERMOSTAT_FAN_MODE.medium;
          isLow = true;
          isMedium = true;
          break;
        case ZHVAC_FAN_SPEED.high:
          _thermostatFanMode = THERMOSTAT_FAN_MODE.high;
          isLow = true;
          isMedium = true;
          isHigh = true;
          break;
        case ZHVAC_FAN_SPEED.auto:
          _thermostatFanMode = THERMOSTAT_FAN_MODE.autoHigh;
          isLow = true;
          isMedium = true;
          isHigh = true;
          isAuto = true;
          break;

        default:
          break;
      }
    } else {
      if (_thermostatFanMode == undefined) {
        _thermostatFanMode =
          this.props.thermostatFanMode || THERMOSTAT_FAN_MODE.low;
      }
      if (
        _thermostatFanMode == THERMOSTAT_FAN_MODE.low ||
        _thermostatFanMode == THERMOSTAT_FAN_MODE.autoLow
      ) {
        isLow = true;
      }
      if (
        _thermostatFanMode == THERMOSTAT_FAN_MODE.medium ||
        _thermostatFanMode == THERMOSTAT_FAN_MODE.autoMedium
      ) {
        isLow = true;
        isMedium = true;
      }

      if (
        _thermostatFanMode == THERMOSTAT_FAN_MODE.high ||
        _thermostatFanMode == THERMOSTAT_FAN_MODE.autoHigh
      ) {
        isLow = true;
        isMedium = true;
        isHigh = true;
      }

      if (
        _thermostatFanMode == THERMOSTAT_FAN_MODE.autoLow ||
        _thermostatFanMode == THERMOSTAT_FAN_MODE.autoMedium ||
        _thermostatFanMode == THERMOSTAT_FAN_MODE.autoHigh
      ) {
        isAuto = true;
      }
    }

    return (
      <HStack
        flexDirection={!IS_WEB ? "row-reverse" : "row"}
        style={{
          alignItems: "baseline",
        }}
      >
        <TouchableOpacity
          onPress={() => {
            this.changeFanMode(THERMOSTAT_FAN_MODE.off);
          }}
        >
          <Text
            style={
              this.props.thermostatFanMode == THERMOSTAT_FAN_MODE.off
                ? styles.fanModeTextActive
                : styles.fanModeText
            }
          >
            off
          </Text>
        </TouchableOpacity>
        {this.renderFanSpeedBars(10, 16, isLow, THERMOSTAT_FAN_MODE.low)}
        {this.renderFanSpeedBars(18, 22, isMedium, THERMOSTAT_FAN_MODE.medium)}
        {this.renderFanSpeedBars(24, 28, isHigh, THERMOSTAT_FAN_MODE.high)}
        <TouchableOpacity
          onPress={() => {
            var shouldAuto = !this.state.isAuto;
            var thermostatFanMode;

            if (shouldAuto) {
              if (_thermostatFanMode == THERMOSTAT_FAN_MODE.low)
                thermostatFanMode = THERMOSTAT_FAN_MODE.autoLow;
              if (_thermostatFanMode == THERMOSTAT_FAN_MODE.medium)
                thermostatFanMode = THERMOSTAT_FAN_MODE.autoMedium;
              if (_thermostatFanMode == THERMOSTAT_FAN_MODE.high)
                thermostatFanMode = THERMOSTAT_FAN_MODE.autoHigh;
            } else {
              if (_thermostatFanMode == THERMOSTAT_FAN_MODE.autoLow)
                thermostatFanMode = THERMOSTAT_FAN_MODE.low;
              if (_thermostatFanMode == THERMOSTAT_FAN_MODE.autoMedium)
                thermostatFanMode = THERMOSTAT_FAN_MODE.medium;
              if (_thermostatFanMode == THERMOSTAT_FAN_MODE.autoHigh)
                thermostatFanMode = THERMOSTAT_FAN_MODE.high;
            }
            this.changeFanMode(thermostatFanMode);
          }}
        >
          <Text
            style={
              this.state.isAuto || isAuto
                ? styles.fanModeTextActive
                : styles.fanModeText
            }
          >
            auto
          </Text>
        </TouchableOpacity>
      </HStack>
    );
  };

  renderFanSpeedBars = (
    minHeight = 0,
    maxHeight = 0,
    isSelected = false,
    value
  ) => {
    // var barHeights = [minHeight, (minHeight + maxHeight) / 2, maxHeight];
    var barHeights = [minHeight];
    return (
      <TouchableOpacity
        style={styles.fanModeBarButton}
        onPress={() => {
          var mode = value;
          if (mode == undefined) {
            mode = THERMOSTAT_FAN_MODE.low;
          }

          if (this.state.isAuto) {
            switch (value) {
              case THERMOSTAT_FAN_MODE.low:
                mode = THERMOSTAT_FAN_MODE.autoLow;
                break;
              case THERMOSTAT_FAN_MODE.medium:
                mode = THERMOSTAT_FAN_MODE.autoMedium;
                break;
              case THERMOSTAT_FAN_MODE.high:
                mode = THERMOSTAT_FAN_MODE.autoHigh;
                break;
            }
          }

          this.changeFanMode(mode);
        }}
      >
        {barHeights.map((height, idx) => (
          <View
            key={idx}
            style={{
              marginHorizontal: 2,
              width: 10,
              height,
              borderColor: COLORS.BORDER,
              borderWidth: 1,
              backgroundColor: isSelected ? COLORS.BORDER : COLORS.WHITE,
            }}
          ></View>
        ))}
      </TouchableOpacity>
    );
  };

  render() {
    var _setPoint =
      Number(this.state.setPoint || this.props.setPoint) || "--.-";
    var _setPointText = Number.isInteger(_setPoint)
      ? `${_setPoint}.0`
      : _setPoint;
    var _setPointUnit =
      this.props.setPointUnit ||
      translate("scenario.stateParamUnits.temperature");
    var _isTurnedOn =
      this.props.isTurnedOn != undefined &&
      typeof this.props.isTurnedOn === "boolean"
        ? this.props.isTurnedOn
        : true;

    return (
      <View style={styles.container}>
        {/* device status */}
        <HStack
          mb="3"
          px="1"
          justifyContent="space-between"
          alignItems="center"
          // flexDirection={IS_WEB ? "row-reverse" : "row"}
        >
          <Text>{this.props.deviceName}</Text>
          <HStack space="2">
            {!Number.isNaN(this.props.currentTemperature) && (
              <View style={styles.statusIconContainer}>
                <SimpleIcon
                  icon={faCharCodes.faThermometerHalf}
                  color={COLORS.MUTED}
                  size={13}
                />
                <Text
                  style={{
                    color: COLORS.MUTED,
                    fontSize: 13,
                    marginHorizontal: 5,
                  }}
                >
                  {this.props.currentTemperature}
                  {this.props.setPointUnit ||
                    translate("scenario.stateParamUnits.temperature")}
                </Text>
              </View>
            )}
            {!Number.isNaN(this.props.humidity) && (
              <View style={styles.statusIconContainer}>
                <SimpleIcon
                  icon={faCharCodes.faTint}
                  color={COLORS.MUTED}
                  size={13}
                />
                <Text
                  style={{
                    color: COLORS.MUTED,
                    fontSize: 13,
                    marginHorizontal: 5,
                  }}
                >
                  {this.props.humidity}
                  {translate("scenario.stateParamUnits.humidity")}
                </Text>
              </View>
            )}
            {this.props.thermostatFanState == THERMOSTAT_FAN_STATE.running && (
              <View style={styles.statusIconContainer}>
                <Text
                  style={{
                    color: COLORS.MUTED,
                    fontSize: 13,
                    marginHorizontal: 5,
                  }}
                >
                  fan:
                </Text>
                <SimpleIcon
                  icon={faCharCodes.faFan}
                  color={COLORS.WHITE}
                  size={13}
                />
              </View>
            )}
            {this.props.thermostatOperatingState != undefined && (
              <View style={styles.statusIconContainer}>
                <SimpleIcon
                  icon={this.getThermostatOperatingStateIcon(
                    this.props.thermostatOperatingState
                  )}
                  color={COLORS.MUTED}
                  size={13}
                />
              </View>
            )}
          </HStack>
        </HStack>
        {/* device actions */}
        <HStack
          space="1"
          style={styles.actionsContainer}
          flexDirection={IS_WEB ? "row-reverse" : "row"}
        >
          {/* thermostat mode */}
          {_isTurnedOn && (
            <View style={[styles.modeContainer, styles.sectionContainer]}>
              {this.state.isChangingMode
                ? this.renderModes(this.props.zhvacUnitNumber)
                : this.renderMode()}
            </View>
          )}
          {!_isTurnedOn && (
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <Switch
                isOn={_isTurnedOn}
                label="off"
                onToggle={() => {
                  this.onToggle(true);
                }}
                size="small"
              />
            </View>
          )}
          {/* set point temp mode */}
          {(_isTurnedOn || this.props.zhvacUnitNumber > 0) && (
            <HStack
              space="2"
              style={[styles.sectionContainer, styles.setPointContainer]}
              flexDirection={!IS_WEB ? "row-reverse" : "row"}
            >
              <TouchableOpacity
                style={styles.setPointButton}
                onPress={() => {
                  this.changeSetPoint(_setPoint - 0.5);
                }}
              >
                <SimpleIcon icon={faCharCodes.faMinus} />
              </TouchableOpacity>
              <Text style={styles.setPointText}>
                {_setPointText}
                {_setPointUnit}
              </Text>
              <TouchableOpacity
                style={styles.setPointButton}
                onPress={() => {
                  this.changeSetPoint(Number(_setPoint) + 1.0);
                }}
              >
                <SimpleIcon icon={faCharCodes.faPlus} />
              </TouchableOpacity>
            </HStack>
          )}
          {/* thermostat fan mode */}
          {(_isTurnedOn || this.props.zhvacUnitNumber > 0) && (
            <View style={[styles.fanContainer, styles.sectionContainer]}>
              {this.renderFanMode()}
            </View>
          )}
        </HStack>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    borderColor: COLORS.BORDER,
    borderWidth: 2,
    // borderBottomWidth: 1,
    // borderBottomColor: Theme.COLORS.BORDER_COLOR,
    borderRadius: 8,
    marginVertical: 15,
    padding: 15,
    marginHorizontal: 10,
  },
  statusContainer: {
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 3,
    //  backgroundColor: COLORS.BORDER,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
  },
  statusIconContainer: {
    alignItems: "center",
  },
  actionsContainer: {
    justifyContent: "space-between",
    height: 80,

    marginVertical: 3,
    padding: 5,
  },
  modeContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  setPointContainer: {
    //backgroundColor: "#efefef",
    alignItems: "center",
    justifyContent: "space-around",
    borderColor: "#888",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderRadius: 0,
    paddingHorizontal: 5,
  },
  fanContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  fanModeBarButton: {
    alignItems: "baseline",
    flex: 1,
    justifyContent: "center",
    borderColor: COLORS.BORDER,
    borderBottomWidth: 2,
    borderRadius: 3,
    paddingBottom: 5,
    paddingHorizontal: 3,
  },
  fanModeTextButton: {},
  fanModeText: {
    marginStart: 7,
    marginEnd: 7,
    fontSize: 10,
    fontWeight: "normal",
    color: COLORS.MUTED,
    textDecorationLine: "line-through",
    textDecorationStyle: "solid",
  },
  fanModeTextActive: {
    marginStart: 7,
    marginEnd: 7,
    fontSize: 12,
    fontWeight: "bold",
    color: COLORS.PRIMARY,
    textDecorationLine: "none",
    textDecorationStyle: "solid",
  },
  sectionContainer: {
    flex: 1,
    borderColor: COLORS.BORDER,
    // borderWidth: 1,
    borderRadius: 5,
  },
  circleButton: {
    width: 38,
    height: 38,
    borderRadius: 19,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.BORDER,
  },
  setPointText: {
    fontSize: 20,
    fontWeight: "bold",
  },
  setPointButton: {
    // borderColor: "red",
    // borderWidth: 1,
    padding: 8,
  },
  economyButtonContainer: {
    width: "80%",
    paddingVertical: 3,
    // backgroundColor: COLORS.ECONOMY_BACKGROUND,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
  },
  economyButton: {
    width: 50,
    flex: 1,
    height: 15,
    marginVertical: 1,
    borderRadius: 3,
    justifyContent: "center",
  },
  economyButtonText: { fontSize: 9, textAlign: "center" },
});

export default AirConditionerThermostat;
